/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPSIGNATORYSTATUS = {
    AwaitingSignatures: 'AwaitingSignatures',
    Complete: 'Complete',
    EmailDeliveryFailure: 'EmailDeliveryFailure',
    Setup: 'Setup',
    TelephoneDeliveryFailure: 'TelephoneDeliveryFailure'
} as const;
export type IAPSIGNATORYSTATUS = typeof IAPSIGNATORYSTATUS[keyof typeof IAPSIGNATORYSTATUS];


export function IAPSIGNATORYSTATUSFromJSON(json: any): IAPSIGNATORYSTATUS {
    return IAPSIGNATORYSTATUSFromJSONTyped(json, false);
}

export function IAPSIGNATORYSTATUSFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPSIGNATORYSTATUS {
    return json as IAPSIGNATORYSTATUS;
}

export function IAPSIGNATORYSTATUSToJSON(value?: IAPSIGNATORYSTATUS | null): any {
    return value as any;
}

